import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useHistory from "routing/useHistory";
import * as JSON from "util/json";
import Routes from "routing/Routes";
import usePluginEntities from "hooks/usePluginEntities";
import { Row, Col, Button, Input, Label } from "components/bootstrap";
import { getValueFromInput } from "util/FormsUtils";
import { lookupDataAdapter } from "components/lookup-tables/hooks/api/lookupTablesAPI";
import useScopePermissions from "hooks/useScopePermissions";
import ConfigSummaryDefinitionListWrapper from "./ConfigSummaryDefinitionListWrapper";
const DataAdapter = ({ dataAdapter, noEdit = false }) => {
  const { t } = useTranslation("lookup_tables");
  const [lookupKey, setLookupKey] = useState("");
  const [lookupResult, setLookupResult] = useState(null);
  const { loadingScopePermissions, scopePermissions } = useScopePermissions(dataAdapter);
  const { push } = useHistory();
  const canEdit = !noEdit && !loadingScopePermissions && (scopePermissions == null ? void 0 : scopePermissions.is_mutable);
  const _onChange = (event) => {
    setLookupKey(String(getValueFromInput(event.target)));
  };
  const _lookupKey = (event) => {
    event.preventDefault();
    lookupDataAdapter(dataAdapter.name, lookupKey).then((result) => {
      setLookupResult(result);
    });
  };
  const handleEdit = () => {
    push(Routes.SYSTEM.LOOKUPTABLES.DATA_ADAPTERS.edit(dataAdapter.name));
  };
  const plugin = usePluginEntities("lookupTableAdapters").find(
    (p) => {
      var _a;
      return p.type === ((_a = dataAdapter.config) == null ? void 0 : _a.type);
    }
  );
  if (!plugin) {
    return /* @__PURE__ */ React.createElement("p", null, t("adapter_summary.unknown_type", { type: dataAdapter.config.type }));
  }
  const { description: adapterDescription } = dataAdapter;
  const summary = plugin.summaryComponent;
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" } }, /* @__PURE__ */ React.createElement(Label, null, plugin.displayName), canEdit && /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: handleEdit, role: "button", name: "edit_square" }, t("common:actions.edit"))), /* @__PURE__ */ React.createElement(ConfigSummaryDefinitionListWrapper, null, /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, t("shared.description")), /* @__PURE__ */ React.createElement("dd", null, adapterDescription || /* @__PURE__ */ React.createElement("em", null, t("shared.no_description"))))), /* @__PURE__ */ React.createElement("hr", null), /* @__PURE__ */ React.createElement("h4", null, t("shared.configuration")), /* @__PURE__ */ React.createElement(ConfigSummaryDefinitionListWrapper, null, React.createElement(summary, { dataAdapter })), /* @__PURE__ */ React.createElement("hr", null), /* @__PURE__ */ React.createElement("h3", null, t("adapter_summary.test_lookup")), /* @__PURE__ */ React.createElement("p", null, t("adapter_summary.test_lookup_description")), /* @__PURE__ */ React.createElement("form", { onSubmit: _lookupKey }, /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "key",
      name: "key",
      label: t("adapter_summary.key_label"),
      required: true,
      onChange: _onChange,
      help: t("adapter_summary.key_help"),
      value: lookupKey
    }
  ), /* @__PURE__ */ React.createElement(Button, { type: "submit", bsStyle: "primary" }, t("adapter_summary.look_up")))), lookupResult && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h4", null, t("adapter_summary.lookup_result")), /* @__PURE__ */ React.createElement("pre", null, JSON.stringify(lookupResult, null, 2)))));
};
export default DataAdapter;
